import { deleteForm, updateForm } from '@store/FormReducer'
import { SBRM, SBRMForm } from '@supplement-bacon/sbrm-react'
import { useAppDispatch, useAppSelector } from '@utils/hooks'
import { forwardRef } from 'react'
import Create from './Create'
import Delete from './Delete'
import Update from './Update'

const Form: SBRMForm = forwardRef(({ formProps }, ref) => {
  const dispatch = useAppDispatch()
  const { error } = useAppSelector((state) => state.form)

  return (
    <SBRM.BaseEntityForm
      {...{ ref, formProps }}
      error={error && String(error)}
      formActions={{
        create: Create,
        update: Update,
        delete: Delete,
      }}
      handlers={{
        create: async () => true,
        update: async (values) =>
          dispatch(updateForm(values)).then(() => {
            return true
          }),
        delete: async (values) =>
          dispatch(deleteForm(values)).then(() => {
            return true
          }),
      }}
    />
  )
})

Form.displayName = 'Form'

type FormType = { Form: typeof Form }

export { Form, type FormType }
